import React, { Component } from "react"
import { isEqual } from "lodash"
import { Spin, Tooltip } from "antd"
import { LeftOutlined, RightOutlined } from "@ant-design/icons"
import { loadTexts } from "../../utils/i18n"

const axis = (calculationType) =>
  calculationType === 1 ? (
    <div className="axis">
      <span>100%</span>
      <span />
      <span>80%</span>
      <span />
      <span>60%</span>
      <span />
      <span>40%</span>
      <span />
      <span>20%</span>
      <span />
      <span>0%</span>
    </div>
  ) : (
    <div className="axis" style={{ gridTemplateRows: "repeat(5, 1fr)" }}>
      <span>5</span>
      <span>4</span>
      <span>3</span>
      <span>2</span>
      <span>1</span>
      <span>0</span>
    </div>
  )

class MultiDrillDown extends Component {
  intlMultiDrilDown = loadTexts("reports_team_analysis_view").multiBarChart
  t = undefined
  id = "ewqeqwewq112"

  componentDidMount = () => {
    this.reloadRows()
    this.scrollers()

    document.querySelector(`#DrillDown_${this.id} #myChart`).onscroll = () =>
      this.scrollers()
  }

  componentDidUpdate = (prevProps) => {
    if (!isEqual(prevProps.data, this.props.data)) {
      this.reloadRows()
      this.scrollers()
    }
  }

  scrollers = () => {
    const chart = document.querySelector(`#DrillDown_${this.id} #myChart`)
    const innerChart = document.querySelector(
      `#DrillDown_${this.id} #myChart_inner`
    )
    const percentDivs = document.querySelectorAll(
      `#DrillDown_${this.id} .multidrilldown-bars__items`
    )
    const formComparate = chart.scrollLeft + chart.offsetWidth

    if (percentDivs[0]) {
      if (
        percentDivs[0].offsetWidth > 150 ||
        formComparate <= innerChart.offsetWidth
      ) {
        if (chart.scrollLeft == 0) {
          document.querySelector(
            `#DrillDown_${this.id} .scrollLeft`
          ).style.opacity = 0
        } else {
          document.querySelector(
            `#DrillDown_${this.id} .scrollLeft`
          ).style.opacity = 1
        }
        if (chart.scrollLeft + chart.offsetWidth == innerChart.offsetWidth) {
          document.querySelector(
            `#DrillDown_${this.id} .scrollRight`
          ).style.opacity = 0
        } else {
          document.querySelector(
            `#DrillDown_${this.id} .scrollRight`
          ).style.opacity = 1
        }
      } else {
        document.querySelector(
          `#DrillDown_${this.id} .scrollRight`
        ).style.opacity = 0
        document.querySelector(
          `#DrillDown_${this.id} .scrollLeft`
        ).style.opacity = 0
      }
    }
  }

  sideScroll = (direction, type) => {
    if (type === "up") {
      clearTimeout(this.t)
      this.start = 100
    } else {
      const element = document.querySelector(`#DrillDown_${this.id} #myChart`)
      if (direction == "left") {
        element.scrollLeft -= 3
      } else {
        element.scrollLeft += 3
      }
      this.t = setTimeout(() => this.sideScroll(direction, type), this.start)
      this.start /= 2
    }
    this.scrollers()
  }

  reloadRows = () => {
    const { subDimensions, data } = this.props
    const chart = document.querySelector(`#DrillDown_${this.id} .chart`)
    const totalBars = document.querySelectorAll(
      `#DrillDown_${this.id} .multidrilldown-container`
    ).length

    const percentDivs = document.querySelectorAll(
      `#DrillDown_${this.id} .multidrilldown-bars__items`
    )
    let barsTotal = 0

    percentDivs.forEach((div) => {
      // if (subDimensions.length || (data[0] ? !Array.isArray(data[0]) : false)) {
      if (data[0] ? !Array.isArray(data[0]) : false) {
        if (percentDivs.length > 5) {
          barsTotal += div.children.length * 40 + 40 + 10 // margin multi bar - margin container bar - ...
        } else {
          barsTotal += div.children.length * 40 + 80 + 40 // margin multi bar - margin container bar - ...
        }
      } else {
        barsTotal += div.children.length * 28 + 20 + 20
      }
    })

    if (percentDivs[0]) {
      chart.style.width = `${180 + barsTotal}px`
      chart.style.setProperty(
        "grid-template-columns",
        `repeat(${totalBars}, min-content)`
      )
    }
  }

  renderDimensions = (item) => {
    return item.map((element, index) => {
      if (element.id_measure === null) {
        return null
      }
      const percentUp=element.percent==0 ? 100:element.percent
      return (
        <div
          key={`${percentUp}-${index}`}
          className="bar multidrilldown-bars__items-bar"
          style={{
            gridRowStart: !element.anonymity_check.valid
              ? 1
              : (percentUp ? 101 : 100) - percentUp,
            cursor: element.childs
              ? element.childs.length
                ? "pointer"
                : ""
              : element.division_childs
              ? "pointer"
              : "",
            width: 28,
            margin: "0 2px",
            backgroundColor: element.value_visible=='0%' ? '#D9D9D9':(!element.anonymity_check.valid
              ? "#D9D9D9"
              : element.color || "#378FEE"),
          }}>
          <Tooltip
            placement="top"
            overlayClassName="tooltipWhite"
            title={
              !element.anonymity_check.valid ? (
                <p style={{ textAlign: "center", marginBottom: "0px" }}>
                  El total de colaboradores debe ser
                  <br />
                  mayor o igual a {element.anonymity_check.current_used} para
                  poder mostrar la
                  <br />
                  información del segmento.
                </p>
              ) : (
                `${element.employees} ${
                  element.employees === 1
                    ? this.intlMultiDrilDown.collaborator
                    : this.intlMultiDrilDown.collaborators
                }`
              )
            }>
            <div
              className="bar-line"
              onClick={() => {
                const { questions } = this.props
                // console.log(element)
                if (element.childs) {
                  if (element.childs.length === 0) return
                }

                // if (element.division_childs) {
                if (element.division_childs === 0) return
                // }

                this.props.handleBarClick(
                  questions.length ? "questions" : "subDimensions",
                  element
                )
              }}
            />
          </Tooltip>
          <div
            className="bar-percent"
            onClick={() => {
              const { questions } = this.props
              if (element.childs.length === 0) return

              this.props.handleBarClick(
                questions.length ? "questions" : "subDimensions",
                element
              )
            }}
            style={{ color: element.color || "#378FEE" }}>
            {!element.anonymity_check.valid ? "" : `${element.value_visible}`}
          </div>
        </div>
      )
    })
  }

  renderSubDimensions = (item) => {
    const { data,loading,switchBars } = this.props
    const percentUp=item.percent==0 ? 100:item.percent
    return (
      <>
      {switchBars && (
        <div>
          {loading && (
            <div className="loadingCss">
              <div style={{ position: "relative", top: "50%" }}>
                <Spin size="large" />
              </div>
            </div>
          )} </div>)}

      <div
        className={`bar ${
          data.length <= 5 ? " bar-long" : ""
        } multidrilldown-bars__items-bar`}
        style={{
          gridRowStart: !item.anonymity_check.valid
            ? 1
            : (percentUp ? 101 : 100) - percentUp,
          cursor: item.childs
            ? item.childs.length
              ? "pointer"
              : ""
            : item.division_childs
            ? "pointer"
            : "",
          margin: "0 20px !important",
          backgroundColor: item.value_visible=='0%' ? '#D9D9D9': (!item.anonymity_check.valid
            ? "#D9D9D9"
            : item.color || "#56CCF2"),
        }}>
        <Tooltip
          placement="top"
          overlayClassName="tooltipWhite"
          title={
            !item.anonymity_check.valid ? (
              <p style={{ textAlign: "center", marginBottom: "0px" }}>
                El total de colaboradores debe ser
                <br />
                mayor o igual a {item.anonymity_check.current_used} para poder
                mostrar la
                <br />
                información del segmento.
              </p>
            ) : (
              `${item.employees} ${
                item.employees === 1
                  ? this.intlMultiDrilDown.collaborator
                  : this.intlMultiDrilDown.collaborators
              }`
            )
          }>
          <div
            className="bar-line"
            onClick={() => {
              const { questions } = this.props
              if (item.childs.length === 0) return

              this.props.handleBarClick(
                questions.length ? "questions" : "subDimensions",
                item
              )
            }}
          />
        </Tooltip>
        <div
          className="bar-percent"
          style={{ color: this.props.questions.length ? "#56CCF2" : "" }}
          onClick={() => {
            const { questions, subDimensions } = this.props

            if (questions.length) return

            if (!subDimensions.length) {
              return this.props.handleBarClick("subDimensions", item)
            }

            this.props.handleBarClick("questions", item)
          }}>
          {!item.anonymity_check.valid ? "" : `${item.value_visible}`}
        </div>
      </div>


    </>
    )
  }

  render() {
    const { loading, level } = this.props

    return (
      <div className="DrillDownComponent" id={`DrillDown_${this.id}`}>
        {loading && (
          <div className="loadingCss">
            <div style={{ position: "relative", top: "50%" }}>
              <Spin size="large" />
            </div>
          </div>
        )}
        <div className="DrillDown">
          {level !== 0 && (
            <div
              className="goBack multidrilldown-bars__goback"
              onClick={() => {
                this.props.handleBackClick()
              }}>
              <span>
                <LeftOutlined /> {this.intlMultiDrilDown.btnGoBack}
              </span>
            </div>
          )}
          {axis(this.props.calculationType)}
          <div className="subContent" id="myChart">
            <div className="chart" id="myChart_inner">
              <div className="topLine" />
              {this.props.data.map((item, i) => {
                return (
                  <div
                    key={i}
                    style={{ display: "grid", position: "relative" }}
                    className="multidrilldown-container">
                    <div
                      className="multidrilldown-bars__items"
                      style={{ margin: Array.isArray(item) ? "0 14px" : 0 }}>
                      {/* { this.renderDimensions(item) } */}
                      {Array.isArray(item)
                        ? this.renderDimensions(item)
                        : this.renderSubDimensions(item)}
                    </div>
                    <div
                      className="bar-name multidrilldown-bars-name"
                      style={{
                        width: "calc(100% - 11px)",
                        margin: "0px 7.5px",
                      }}>
                      <Tooltip
                        placement="bottom"
                        title={
                          Array.isArray(item)
                            ? item[item.length - 1].name
                            : item.name
                        }>
                        {Array.isArray(item)
                          ? item[item.length - 1].name
                          : item.name}
                      </Tooltip>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>

          <div
            className="scrollSide scrollLeft"
            style={{ left: 0, opacity: 0 }}>
            <LeftOutlined
              style={{ color: "#979797" }}
              onMouseUp={() => this.sideScroll("left", "up")}
              onMouseDown={() => this.sideScroll("left", "down")}
            />
          </div>
          <div
            className="scrollSide scrollRight"
            style={{ right: 0, opacity: 0 }}>
            <RightOutlined
              style={{ color: "#979797" }}
              onMouseUp={() => this.sideScroll("right", "up")}
              onMouseDown={() => this.sideScroll("right", "down")}
            />
          </div>
        </div>
      </div>
    )
  }
}
MultiDrillDown.defaultProps = {
  switchBars: false
};
export default MultiDrillDown
